import axios from "axios";
import config from "../../../config/index";

import {
    RECIPIENT_ALL,
    SENDER_ALL,
    FILE_SHARE,
    RECENT_DOCUMENT,
} from "../types/types";

const instance = axios.create({
    baseURL: config.SIM_API_URL,
    timeout: 30000,
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if(error.response.status === 403) {
        localStorage.setItem("role", '');
        localStorage.setItem("client", '');
        localStorage.setItem("client_id", '');
        localStorage.setItem("client_name", '');
        localStorage.setItem("client_email", '');
        window.location.href = "/login";
    }
    return Promise.reject(error);
});


export function fileUpload(data) {
    console.log("data = ", data);
    return instance.post("api/documents/upload", data);
}

export const reset = () => dispatch => {
    dispatch({
        type: FILE_SHARE,
        payload: '',
    });
};

export const getDocumentRecipients = (data) => dispatch => {
    instance
        .post("api/documents/document-client-recipient", data)
        .then(res => {
            dispatch({
                type: RECIPIENT_ALL,
                payload: res.data.results,
            });
        })
        .catch(err => {
            console.log(err.toString());
        })
};

export const getDocumentSenders = (data) => dispatch => {
    instance
        .post("api/documents/document-client-sender", data)
        .then(res => {
            dispatch({
                type: SENDER_ALL,
                payload: res.data.results,
            });
        })
        .catch(err => {
            console.log(err.toString());
        })
};

export const ShareDocument = (data) => dispatch => {
    instance
        .post("api/documents/share-with", data)
        .then(res => {
            dispatch({
                type: FILE_SHARE,
                payload: res.data.msg,
            });
        })
        .catch(err => {
            dispatch({
                type: FILE_SHARE,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

export const getDocumentSharedWithMe = (data) => dispatch => {
    instance
        .post("api/documents/shared-with-me", data)
        .then(res => {
            dispatch({
                type: RECENT_DOCUMENT,
                payload: res.data.results,
            });
        })
        .catch(err => {
            console.log(err.toString());
        })
};